'use es6';

import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
const initialState = null;
export default handleActions({
  [ActionTypes.GLOBAL_BRANDING_FETCH_SUCCEEDED](state, action) {
    return action.payload;
  }
}, initialState);